import { Popover, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import FormService from "../../../../components/generic/formbuilder/networkservice/FormService";
import VisitPopoverContent from "../visitlist/VisitPopoverContent";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useNavigate } from "react-router-dom";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const Task = ({
  templateCodes,
  opportunity,
  patientIdentifier,
  carePlanId,
}) => {
  const navigate = useNavigate();
  const role = useGetRole();
  const [serviceForms, setServiceForms] = useState([]);
  const organizationIdentifier = useGetOrgIdentifier();

  const handleFormView = async () => {
    if (templateCodes[0]) {
      navigate(
        `${RoleToLinkMapper(role)}form-viewer?templateCode=${
          templateCodes[0]
        }&patientIdentifier=${patientIdentifier}&workforceIdentifier=${
          opportunity?.workforceIdentifier
        }&readOnly=${false}&opportunityId=${
          opportunity?.id
        }&carePlanId=${carePlanId}`
      );
    }
  };

  useEffect(() => {
    const formService = new FormService();

    const getForms = async () => {
      const formsList =
        (await formService.getAllFormMetaData(organizationIdentifier))?.data ||
        [];

      if (!templateCodes?.length) return [];

      const formsMap = new Map(
        formsList.map((form) => [form.templateCode, form.title])
      );

      const list = templateCodes
        .map((templateCode) => ({
          templateCode,
          title: formsMap.get(templateCode),
        }))
        .filter((item) => item.title);

      setServiceForms(list);
    };

    if (templateCodes?.length > 1) {
      getForms();
    }
  }, [organizationIdentifier, templateCodes]);

  return (
    <>
      {serviceForms?.length > 1 ? (
        <Popover
          arrowPointAtCenter
          placement="bottomRight"
          content={
            <VisitPopoverContent
              visit={{ serviceForms, patientIdentifier, opportunity }}
            />
          }
          overlayClassName="actioncard-popover"
          trigger="click"
        >
          <Tooltip title="Submit Report" placement="bottom">
            <>
              <SmartIcon iconKey={"add"} />
            </>
          </Tooltip>
        </Popover>
      ) : (
        <Tooltip title="Submit Report" placement="bottom">
          <>
            <SmartIcon iconKey={"add"} handleIconClick={handleFormView} />
          </>
        </Tooltip>
      )}
    </>
  );
};

export default Task;
